export default [
  {
    path: '/order_settings',
    meta: { label: 'Order Settings' },
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '',
        name: 'order_settings',
        meta: {
          label: 'Order Settings',
          permission: 'show_all_order_settings'
        },
        component: () => import('./../../views/orderSettings/index'),
      },
      {
        path: ':id',
        meta: { label: 'Order Setting Details', permission: 'show_single_order_setting' },
        name: 'OrderSetting',
        component: () => import('./../../views/orderSettings/show'),
      },
      {
        path: ':id/edit',
        meta: { label: 'Edit Order Setting', permission: 'edit_order_setting' },
        name: 'EditOrderSetting',
        component: () => import('./../../views/orderSettings/edit')
      },
    ]
  },
  {
    path: "order_payment_methods",
    name: "order_payment_methods",
    component: () => import("@/views/paymentmethods/index.vue"),
    meta: {
      permission: "show_all_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/create",
    name: "create_order_payment_method",
    component: () => import("@/views/paymentmethods/create.vue"),
    meta: {
      permission: "create_order_payment_methods",
    },
  },
  {
    path: "order_payment_method/:id/edit",
    name: "edit_order_payment_method",
    component: () => import("@/views/paymentmethods/edit.vue"),
    meta: {
      permission: "edit_order_payment_method",
    },
  },
];
